import React from 'react';
import { ProgressBar } from 'primereact/progressbar';
import { Badge } from 'primereact/badge';
import './CustomProgressBar.css';

function CustomProgressBar({
  passed = 0,
  failed = 0,
  inProgress = 0,
  notExecuted = 0,
  total = 0,
  current = 0,
  consecutiveFails = 0,
}) {
  inProgress = total - (passed + failed + notExecuted);
  const value = total > 0 ? Math.floor((current * 100) / total) : 0;

  return (
    <div className='custom-progress-bar-container'>
      <ProgressBar
        value={value}
        pt={{
          value: { style: { backgroundColor: '#124069' } },
          root: { style: { height: '25px' } },
        }}
      />
      <div className='custom-progress-bar-info-panel'>
        <div className='status-badge'>
          <Badge value={passed} size='xlarge' severity='success' />
          <span className='status-text'>Passed</span>
        </div>
        <div className='status-badge'>
          <Badge value={failed} size='xlarge' severity='danger' />
          <span className='status-text'>Failed</span>
        </div>
        <div className='status-badge'>
          <Badge value={inProgress} size='xlarge' severity='info' />
          <span className='status-text'>In Progress</span>
        </div>
        <div className='status-badge'>
          <Badge value={notExecuted} size='xlarge' severity='warning' />
          <span className='status-text'>Not Executed</span>
        </div>
        <div className='status-badge'>
          <Badge value={total} size='xlarge' severity='secondary' />
          <span className='status-text'>Total</span>
        </div>
        {consecutiveFails > 0 && (
          <div className='status-badge'>
            <Badge
              value={consecutiveFails}
              size='xlarge'
              className='consecutive-fails'
              style={{ backgroundColor: 'burlywood' }}
            />
            <span className='status-text'>Consecutive Fails</span>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomProgressBar;
